import * as Sentry from "@sentry/react";

type SpanOp = string;

type SpanContext = {
  op: SpanOp;
  name: string;
  attributes?: Record<string, unknown>;
};

export const startSpan = async <T>(context: SpanContext, callback: () => Promise<T>): Promise<T> => {
  return Sentry.startSpan(context, callback);
};

export const startSyncSpan = <T>(context: SpanContext, callback: () => T): T => {
  return Sentry.startSpan(context, callback);
};

export const captureException = (error: unknown, extra?: Record<string, unknown>) => {
  Sentry.captureException(error, (scope) => {
    if (extra) {
      scope.setContext("extra", extra);
    }
    return scope;
  });
};

export const logger = Sentry.getClient()?.getOptions().logger ?? Sentry.logger;

export { Sentry };
